import * as z from "zod";

export const qualifierSchema = z.object({
  id: z.string(),
  itemId: z.string(),
  text: z.string(),
  sortOrder: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Qualifier = z.infer<typeof qualifierSchema>;

export const listQualifiersInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
});

export const listQualifiersResponseSchema = z.object({
  qualifiers: z.array(qualifierSchema),
});

export const createQualifierInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
  text: z.string().min(1),
});

export const createQualifierResponseSchema = z.object({
  qualifier: qualifierSchema,
});

export const updateQualifierInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
  text: z.string().min(1).optional(),
  sortOrder: z.number().optional(),
});

export const updateQualifierResponseSchema = z.object({
  qualifier: qualifierSchema,
});

export const deleteQualifierInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
});

export const deleteQualifierResponseSchema = z.object({
  ok: z.literal(true),
});

export const reorderQualifiersInputSchema = z.object({
  organizationId: z.string(),
  itemId: z.string(),
  orderedIds: z.array(z.string()).min(1),
});

export const reorderQualifiersResponseSchema = z.object({
  ok: z.literal(true),
});
